function c(n) {
  return Array.isArray(n) ? n : [n];
}
const a = {
  STOP: "STOP"
};
function s(n, r) {
  const e = r(n);
  n.children !== void 0 && e !== a.STOP && n.children.forEach((i) => s(i, r));
}
function o(n, r = {}) {
  const { preserveGroup: e = !1 } = r, i = [], f = e ? (t) => {
    t.isLeaf || (i.push(t.key), u(t.children));
  } : (t) => {
    t.isLeaf || (t.isGroup || i.push(t.key), u(t.children));
  };
  function u(t) {
    t.forEach(f);
  }
  return u(n), i;
}
function l(n, r) {
  const { isLeaf: e } = n;
  return e !== void 0 ? e : !r(n);
}
function d(n) {
  return n.children;
}
function y(n) {
  return n.key;
}
function h() {
  return !1;
}
function A(n, r) {
  const { isLeaf: e } = n;
  return !(e === !1 && !Array.isArray(r(n)));
}
function p(n) {
  return n.disabled === !0;
}
function v(n, r) {
  return n.isLeaf === !1 && !Array.isArray(r(n));
}
function L(n, r) {
  if (n.isLeaf === !0) {
    const e = r(n);
    if (Array.isArray(e) && e.length > 0)
      return !0;
  }
  return !1;
}
function m(n) {
  var r;
  return n == null ? [] : Array.isArray(n) ? n : (r = n.checkedKeys) !== null && r !== void 0 ? r : [];
}
function E(n) {
  var r;
  return n == null || Array.isArray(n) ? [] : (r = n.indeterminateKeys) !== null && r !== void 0 ? r : [];
}
function S(n, r) {
  const e = new Set(n);
  return r.forEach((i) => {
    e.has(i) || e.add(i);
  }), Array.from(e);
}
function G(n, r) {
  const e = new Set(n);
  return r.forEach((i) => {
    e.has(i) && e.delete(i);
  }), Array.from(e);
}
function K(n) {
  return (n == null ? void 0 : n.type) === "group";
}
function g(n) {
  const r = /* @__PURE__ */ new Map();
  return n.forEach((e, i) => {
    r.set(e.key, i);
  }), (e) => {
    var i;
    return (i = r.get(e)) !== null && i !== void 0 ? i : null;
  };
}
export {
  a as TRAVERSE_COMMAND,
  g as createIndexGetter,
  d as defaultGetChildren,
  y as defaultGetKey,
  o as getNonLeafKeys,
  p as isDisabled,
  v as isExpilicitlyNotLoaded,
  K as isGroup,
  h as isIgnored,
  l as isLeaf,
  L as isNodeInvalid,
  A as isShallowLoaded,
  S as merge,
  G as minus,
  c as toArray,
  s as traverseWithCb,
  m as unwrapCheckedKeys,
  E as unwrapIndeterminateKeys
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/treemate@0.3.11/~/treemate/es/utils.js
// module id = 322
// module chunks = 41